import { computed } from "vue";
import { usePatientStore } from "../store/patientStore";
import type { PatientCategory, SortColumn } from "@virtual-care/shared";

export function usePatientList() {
  const patientStore = usePatientStore();

  const patients = computed(() => patientStore.filteredPatients);
  const patientGroups = computed(() => patientStore.patientGroups);
  const totalPatientCount = computed(() => patientStore.totalPatientCount);
  const filterCounts = computed(() => patientStore.filterCounts);
  const selectedFilters = computed(() => patientStore.selectedFilters);
  const searchQuery = computed(() => patientStore.searchQuery);
  const sortColumn = computed(() => patientStore.sortColumn);
  const sortDirection = computed(() => patientStore.sortDirection);
  const loading = computed(() => patientStore.loading);
  const error = computed(() => patientStore.error);
  const units = computed(() => patientStore.units);
  const selectedUnit = computed(() => patientStore.selectedUnit);

  const toggleFilter = (category: PatientCategory) => {
    patientStore.toggleFilter(category);
  };

  const clearFilters = () => {
    patientStore.clearFilters();
  };

  const setSearchQuery = (query: string) => {
    patientStore.setSearchQuery(query);
  };

  const setSortColumn = (column: SortColumn) => {
    patientStore.setSortColumn(column);
  };

  const toggleGroupExpanded = (groupId: string) => {
    patientStore.toggleGroupExpanded(groupId);
  };

  const loadPatients = async (unitId?: string) => {
    await patientStore.loadPatients(unitId);
  };

  return {
    patients,
    patientGroups,
    totalPatientCount,
    filterCounts,
    selectedFilters,
    searchQuery,
    sortColumn,
    sortDirection,
    loading,
    error,
    units,
    selectedUnit,
    toggleFilter,
    clearFilters,
    setSearchQuery,
    setSortColumn,
    toggleGroupExpanded,
    loadPatients,
  };
}
